
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/loesungen",
      function () {
        return require("private-next-pages/[locale]/loesungen.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/loesungen"])
      });
    }
  